import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_payment_line_RowClass} from '../../../dbschema';

export class ClaimCyclePaymentLineContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_payment_line: bl_aat_claim_cycle_payment_line_RowClass = new bl_aat_claim_cycle_payment_line_RowClass();
}
